/**
 * @description CSS Values
 */
export enum CSSValue {
	IMPORTANT = 'important'
}